const timeCardReportFilters = {
  startDate: null,
  endDate: null,
  clientId: null,
  userId: null,
  assignmentId: null
}

export default () => Object.assign({}, timeCardReportFilters)
